import React, { useEffect, useState } from 'react';
import lightPDFIcon from './assets/pdf-light.png';
import darkPDFIcon from './assets/pdf-dark.png';

const PDFViewer = ({ userId, filename, onClose, docType }) => {
  const [signedUrl, setSignedUrl] = useState(null);
  const [popup, setPopup] = useState(null);

  useEffect(() => {
    const fetchSignedUrl = async () => {
      if (!userId || !filename) return;
      try {
        const res = await fetch(`${process.env.REACT_APP_GET_PDFS}/${userId}/${filename}`);
        const data = await res.json();
        if (data?.url) {
          setSignedUrl(data.url);
        }
      } catch (err) {
        console.error('Failed to fetch signed PDF URL:', err);
      }
    };
    fetchSignedUrl();
  }, [userId, filename]);

  // open popup when signedUrl is ready
  useEffect(() => {
    if (!signedUrl) return;

    const newWin = window.open(
      '',
      filename,
      'width=900,height=700,resizable=yes,scrollbars=yes'
    );

    if (newWin) {
      newWin.document.write(`
        <html>
          <head>
            <title>${filename}</title>
            <style>
              body, html {
                margin: 0;
                padding: 0;
                height: 100%;
                width: 100%;
                overflow: hidden;
              }
              iframe {
                border: none;
                width: 100%;
                height: 100%;
              }
            </style>
          </head>
          <body>
            <iframe src="${signedUrl}" title="PDF Viewer"></iframe>
          </body>
        </html>
      `);
      setPopup(newWin);

      // cleanup if popup is closed directly by user
      const timer = setInterval(() => {
        if (newWin.closed) {
          clearInterval(timer);
          onClose?.();
        }
      }, 500);
    }

    return () => {
      if (popup && !popup.closed) {
        popup.close();
      }
    };
  }, [signedUrl]);

  if (!signedUrl) {
    return <div style={{ fontSize: 12 }}>Loading PDF...</div>;
  }

return null
};

export default PDFViewer;
